export default __webpack_public_path__ + "static/media/um.dd4649fc.jpg";